import React from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router";

//
import IMGLOGO from "../../assets/images/logo.png";

export default function Logo({ size }) {
  const navigate = useNavigate();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledLogo $size={size} onClick={() => handleNavigate("/")}>
      <img src={IMGLOGO} alt="IMGLOGO" />
      <p>
        Choriqul <br /> Shaymatov <br /> Gavhari
      </p>
    </StyledLogo>
  );
}

const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    height: 75px;
  }

  p {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px; /* 131.579% */
    color: var(--white);
    margin-left: 22px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 2px;
      height: 85%;
      background-color: var(--white);
      top: 50%;
      transform: translateY(-50%);
      left: -12px;
    }
  }

  ${({ $size }) =>
    $size === "lg" &&
    css`
      img {
        height: 85px;
      }

      p {
        font-size: 22px;
        line-height: 30px; /* 131.579% */
      }
    `}
`;
